export default __webpack_public_path__ + "static/men-bodymap-tshirt-b9d8b9c4677581674279010653f4bfa1.webp";